import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { RoleTypes } from "@app-cmc/models";
import { UserPermissionService } from "clearline-common";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AccountService } from "./account.service";
import { AuthService } from "./auth.service";

@Injectable()
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
    private accountSvc: AccountService,
    private userPermissionService: UserPermissionService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.userPermissionService.ready$.pipe(
      map(() => {
        let result = this.checkLogin();
        if (!result) {
          this.authService.login();
          return result;
        }

        result = this.checkRole(state) && this.userPermissionService.hasRoutePermission(state.url);
        if (!result) {
          this.router.navigate(["/access-denied"]);
          return result;
        }

        result = this.hasLocation(state);
        if (!result) {
          // this.router.navigate(["/choose-location"]);
          this.router.navigate(["/"]);
          return result;
        }

        return result;
      })
    );
  }

  private checkRole(state: RouterStateSnapshot) {
    const result = this.authService.requredMinimumRole(RoleTypes.PartnerAdmin);
    if (result && state.url !== "/access-denied") {
      return false;
    }
    return true;
  }
  private checkLogin(): boolean {
    if (this.authService.isLoggedIn) {
      return true;
    }
    return false;
  }

  isManagerAccountConfigured(state: RouterStateSnapshot) {
    const user = this.accountSvc.user;
    const result = !user.configured;
    if (result && state.url !== "/access-denied") {
      return false;
    }
    return true;
  }

  hasLocation(state: RouterStateSnapshot) {
    const user = this.accountSvc.user;
    const result = !user.locationId;
    if (result && state.url !== "/") {
      return false;
    }
    return true;
  }
}
